import axiosIns from '@/plugins/axios'

export default {
  getCustomerUsageTime() {
    return axiosIns.get('/v2/monitor/vending_histories/customer_usage_time')
  },
}
